import { ReactNode } from 'react'
import styled, { css } from 'styled-components'

export const fieldInputStyles = css`
	border: none;
	outline: none;
	box-shadow: none;
	padding: 0.5em;
	font-size: 16px;
	border-bottom: solid 1px ${props => props.theme.colors.midNeutral.light(0).val};
	color: ${props => props.theme.colors.secondary.val};
	background: none;
	width: 100%;
	text-align: left;
	border-radius: 0;

	&input[type='date'],
	&input[type='select'] {
		align-items: flex-start;
		display: block;
	}
`

export const boxFieldStyles = css`
	border: none;
	background: ${props => props.theme.colors.white.val};

	&::placeholder {
		color: ${props => props.theme.colors.secondary.val};
	}
`

export const labelStyles = css`
	font-size: 0.8rem;
	color: ${props => props.theme.colors.text.light().val};
`

export const fieldStyles = css`
	margin-bottom: 0.5em;

	&.__space-bottom {
		margin-bottom: 2em;
	}
	&.__space-right {
		margin-right: 2em;
	}

	.label-content {
		display: inline-block;
		${labelStyles}
	}
	input,
	select,
	textarea {
		${fieldInputStyles}
	}

	&.__box {
		input,
		select,
		textarea {
			${boxFieldStyles}
		}
	}
	&.label-pos-left {
		label {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-end;
		}
		input {
			width: auto;
			margin-right: 0.5em;
		}
	}

	&.label-pos-bottom {
		label {
			display: flex;
			flex-direction: column-reverse;
		}
		input {
			width: auto;
			margin-left: 0.5em;
		}
	}

	&.label-pos-right {
		label {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex-direction: row;
		}
	}

	.required-asterix {
		color: ${props => props.theme.colors.err.val};
	}
`

const FieldView = styled.div`
	${fieldStyles}
`

export type FieldProps = {
	label?: ReactNode
	labelPos?: 'top' | 'left' | 'bottom' | 'right'
	name?: string
	className?: string
	spaceBottom?: boolean
	spaceRight?: boolean
	displayType?: 'underline' | 'box'
	isReq?: boolean
	children?: ReactNode
}
export const Field = ({
	children,
	className,
	label,
	labelPos = 'top',
	spaceBottom,
	spaceRight,
	displayType = 'underline',
	isReq,
	name,
}: FieldProps) => {
	return (
		<FieldView
			className={`field-wrap${className ? ` ${className}` : ''}${
				spaceBottom ? ' __space-bottom' : ''
			}${spaceRight ? ' __space-right' : ''}${
				displayType === 'underline' ? ' __underline' : displayType === 'box' ? ' __box' : ''
			} label-pos-${labelPos}`}
		>
			{label || isReq ? (
				<label htmlFor={name}>
					{labelPos !== 'right' ? (
						<div className='label-content'>
							{label}
							{isReq ? <span className='required-asterix'>*</span> : null}
						</div>
					) : null}
					{children}
					{labelPos === 'right' ? (
						<div className='label-content'>
							{label}
							{isReq ? <span className='required-asterix'>*</span> : null}
						</div>
					) : null}
				</label>
			) : (
				children
			)}
		</FieldView>
	)
}
